export default "__VITE_ASSET__CVXez_gv__"